<template>
    <div v-if="meetup">
        <cm-back
            sectionTitle="Attendees list"
            :contentName="meetup ? meetup.name : 'Loading...'"
            :to="{name: 'manage', query: {view: 'meetups'}}"
        ></cm-back>
        <!-- SUBMENU STARTS HERE -->
        <div class="submenu-general mb-3">
            <div class="container">
                <ul class="px-0 text-center">
                    <li
                        :class="{selected: $route.query.list === 'attendees' || !$route.query.list}"
                        @click="$route.query.list !== 'attendees' && $router.push({query: {list: 'attendees'}})"
                    >
                        <span>ATTENDEES LIST</span>
                    </li>
                    <li
                        :class="{selected: $route.query.list === 'waiting'}"
                        @click="$route.query.list !== 'waiting' && $router.push({query: {list: 'waiting'}})"
                    >
                        <span>WAITING LIST</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- SUBMENU ENDS HERE -->
        <section class="users-list container" v-if="!loading && $route.query.list !== 'waiting'">
            <div class="d-flex align-items-center justify-content-center flex-column">
                <md-menu md-align-trigger class="d-md-none mb-3 p-0 w-100" v-if="users.length">
                    <md-button md-menu-trigger class="w-100">
                        Download list
                        <i class="mdi mdi-menu-down"></i>
                    </md-button>

                    <md-menu-content>
                        <md-menu-item @click="getPartecipantsList()">Download full list (.CSV)</md-menu-item>
                        <md-menu-item @click="makePDF('full')">
                            <b-spinner v-if="loadPdf.full" small class="mr-2"></b-spinner>Download full list (.PDF)
                        </md-menu-item>
                        <md-menu-item @click="makePDF('reception')">
                            <b-spinner v-if="loadPdf.reception" small class="mr-2"></b-spinner>Download list for receptionist
                        </md-menu-item>
                    </md-menu-content>
                </md-menu>
                <div class="d-none d-md-inline-block" v-if="users.length">
                    <a @click="getPartecipantsList()">
                        <button
                            class="btn btn-sm btn-outline-success mb-3 mr-md-3"
                        >Download full list (.CSV)</button>
                    </a>
                    <button
                        class="btn btn-sm btn-outline-success mb-3 mr-md-3"
                        @click="makePDF('full')"
                    >
                        <b-spinner v-if="loadPdf.full" small class="mr-2"></b-spinner>Download full list (.PDF)
                    </button>
                    <button
                        class="btn btn-sm btn-outline-success mb-3"
                        @click="makePDF('reception')"
                    >
                        <b-spinner v-if="loadPdf.reception" small class="mr-2"></b-spinner>Download list for receptionist
                    </button>
                </div>
                <b-table
                    :items="users"
                    stacked="sm"
                    :fields="fields"
                    v-if="users.length"
                    class="users-table"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                ></b-table>
                <div class="d-none">
                    <div class="px-5 py-5" id="reception">
                        <h5 class="mb-4 d-flex flex-wrap">
                            {{meetup.name}} -
                            <span
                                class="ml-1"
                            >{{this.meetup.start_datetime.substring(0,16)}} UTC | {{this.meetup.end_datetime.substring(0,16)}} UTC</span>
                        </h5>
                        <b-table
                            bordered
                            outlined
                            small
                            sort-by="surname"
                            :items="users"
                            :fields="['name', 'surname', 'sign']"
                        ></b-table>
                    </div>
                    <div class="px-5 py-5" id="full">
                        <h5 class="mb-4">{{meetup.name}} - Reservations</h5>
                        <b-table
                            bordered
                            outlined
                            small
                            sortable
                            :sort-desc.sync="sortDesc"
                            :sort-by.sync="sortBy"
                            :items="users"
                            :fields="fields.map(m => m.key !== 'check' ? m.key : m.label)"
                        ></b-table>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="users-list container"
            v-else-if="!loading && $route.query.list === 'waiting' && waiting.length"
        >
            <div class="d-flex align-items-center justify-content-center flex-column">
                <div
                    class="d-flex table-actions flex-sm-row flex-column justify-content-start w-100 mb-2"
                >
                    <button @click="selectAll" class="primary mr-sm-2 mb-2 mb-sm-0">Select all</button>
                    <button @click="clearSelected" class="mr-sm-2">Clear selection</button>
                </div>
                <b-table
                    :items="waiting"
                    selectable
                    ref="waitingList"
                    select-mode="multi"
                    stacked="sm"
                    :fields="waitingFields"
                    v-if="waiting.length"
                    class="waiting-table"
                    @row-selected="items => selected = items"
                >
                    <template v-slot:cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                        </template>
                    </template>
                </b-table>
                <div class="w-100 text-right">
                    <button
                        class="btn btn-primary"
                        :disabled="meetup.status === 'draft' || !selected.length || adding"
                        @click="addSelected"
                    >
                        <b-spinner v-if="adding" variant="light" small class="mr-2"></b-spinner>
                        Add selected ({{selected.length}})
                    </button>
                </div>
            </div>
        </section>
        <div v-else-if="loading" class="w-100 d-flex justify-content-center p-5">
            <b-spinner></b-spinner>
        </div>
        <div v-else>
            <code-message>The waiting list is empty.</code-message>
        </div>
        <md-dialog-alert
            md-title="Result"
            :md-content="resultMessage"
            :md-active.sync="result"
            @md-closed="load"
        ></md-dialog-alert>
    </div>
</template>
<script>
import html2pdf from "html2pdf.js";
import CmBack from "@/components/CmBack";
import CodeMessage from "@/components/CodeMessage";

export default {
    name: "AttendeesList",
    components: {
        CmBack,
        CodeMessage
    },
    async mounted() {
        await this.load();
    },
    data: () => ({
        users: [],
        waiting: [],
        fields: [
            { key: "name", sortable: true },
            { key: "surname", sortable: true },
            { key: "email", sortable: true },
            { key: "check", label: "Checked-in", sortable: true }
        ],
        waitingFields: ["selected", "name", "surname", "email"],
        loading: false,
        loadPdf: { full: false, reception: false },
        selected: [],
        adding: false,
        result: false,
        resultMessage: "",
        sortBy: "surname",
        sortDesc: false
    }),
    computed: {
        community() {
            return this.$store.getters.community;
        },
        meetup() {
            return this.$store.getters.meetup;
        }
    },
    methods: {
        async load() {
            this.loading = true;
            if (!this.meetup) {
                try {
                    const community = await this.$communityApi.getCommunity(
                        this.$route.params.id
                    );
                    this.$store.commit("setCommunity", community);
                } catch (error) {
                    console.error(error);
                    this.$router.push("/communities#management");
                    return;
                }
                try {
                    const meetup = await this.$meetupApi.getMeetupById(
                        this.$route.params.meetupid
                    );
                    this.$store.commit("setMeetup", meetup.data);
                } catch (error) {
                    console.error(error);
                }
            }
            try {
                // this.users = await this.$reservationApi.checkinList(
                //     this.$route.params.meetupid
                // );

                this.users = await this.$meetupApi.getMeetupAttendees(
                    this.$route.params.meetupid,
                    "attendees"
                );

                const checkedIn = await this.$reservationApi.checkinList(
                    this.$route.params.meetupid
                );

                if (checkedIn.length) {
                    this.users.forEach(user => {
                        const index = checkedIn.findIndex(
                            el => el.email === user.email
                        );

                        if (index >= 0) {
                            user.check = "Yes";
                        } else {
                            user.check = "-";
                        }
                    });
                }

                this.waiting = await this.$meetupApi.getMeetupAttendees(
                    this.$route.params.meetupid,
                    "waiting"
                );
            } catch (error) {
                console.error(error);
            }
            this.loading = false;
        },
        async makePDF(type) {
            this.loadPdf[type] = true;
            await html2pdf()
                .set({
                    margin: [2, 1],
                    filename: this.meetup.slug + "-attendees.pdf"
                })
                .from(document.querySelector("#" + type))
                .save();
            this.loadPdf[type] = false;
        },
        selectAll() {
            this.$refs.waitingList.selectAllRows();
        },
        clearSelected() {
            this.$refs.waitingList.clearSelected();
        },
        async addSelected() {
            this.adding = true;
            try {
                const res = await this.$meetupApi.addUsersFromWaitingList({
                    meetup_id: this.meetup.id,
                    users: this.selected.map(user => ({
                        name: user.name,
                        email: user.email,
                        uid: user.uid
                    })),
                    force: true
                });
                this.resultMessage =
                    "Success! " +
                    this.selected.length +
                    " attendee" +
                    (this.selected.length > 1 ? "s" : "") +
                    " added.";
            } catch (error) {
                this.resultMessage = "Something went wrong. Error: " + error;
                console.error(error);
            } finally {
                this.result = true;
                this.adding = false;
            }
        },
        async getPartecipantsList() {
            await this.$meetupApi.exportAttendeesToCsv(
                this.$route.params.meetupid,
                "attendees"
            ); 
        }
    }
};
</script>
<style lang="scss">
.table.b-table.b-table-stacked-sm div {
    word-wrap: break-word;
}

.md-list-item-content:not(.md-disabled) {
    color: #0d1d30 !important;
    font-weight: normal !important;
}

.users-list {
    .md-menu {
        border-radius: 24px;
    }
    .md-button {
        border-radius: 24px;
        background: #ff5c00;
        .md-button-content {
            color: white;
            font-weight: 600;
            font-size: 16px;
        }
    }
}
.table thead th {
    vertical-align: bottom;
    border-bottom: 1px solid #f0f0f0 !important;
}

.table th,
.table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 0px solid #f0f0f0 !important;
}
</style>

<style lang="scss" scoped>
@import "../assets/scss/common";

.submenu-general {
    border-bottom: 1px solid #ededed;
    .container {
        ul {
            display: flex;
            justify-content: center;
            list-style: none;
            li {
                padding: 10px 15px;
                // margin: 0 20px;
                font-weight: 600;
                cursor: pointer;
                &.selected {
                    border-bottom: 2px solid $orange;
                    span {
                        color: $orange;
                    }
                }
                span {
                    transition: all 0.5s ease;
                    color: $black;
                }
                &:hover {
                    span {
                        color: $orange;
                    }
                }
            }
        }
    }
}

.waiting-table {
    @media all and (min-width: $size-large-portrait) {
        min-width: 750px;
    }
}

.table-actions {
    button {
        &:focus {
            outline: none;
        }
        background: transparent;
        border: 1px solid $palette-blue;
        border-radius: 1rem;
        padding: 2px 10px;
        text-transform: uppercase;
        &.primary {
            background: $palette-blue;
            color: white;
        }
    }
}
.users-list {
    max-width: 1440px;
    padding: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    table {
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
        border: transparent !important;

        -webkit-box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
        box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
        background-color: #fff;
    }
}
</style>